import { QualityTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("qaqc_product_counts")
export class QAQCProductCountsEntity {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column({
        name: "test_date",
        type: "datetime"
    })
    testDate: Date;

    @Column("varchar", {
        nullable: true,
        name: "process_type",
        length: 255
    })
    processType: string;

    @Column("varchar", {
        nullable: true,
        name: "lot_number",
        length: 255
    })
    lotNumber: string;

    @Column("varchar", {
        nullable: true,
        name: "operation",
        length: 100
    })
    operation: string;



    @Column("varchar", {
        nullable: false,
        name: "product",
        length: 100
    })
    product: Number;

    @Column("enum", {
        enum: QualityTypeEnum,
        nullable: true,
        name: "quality"
    })
    quality: QualityTypeEnum;

    @Column("decimal", {
        nullable: false,
        precision: 10,
        scale: 3,
        name: "quantity"
    })
    quantity: number;

    @Column("varchar", {
        nullable: true,
        name: "product_type",
        length: 50
    })
    productType: string;

    @Column("int", {
        nullable: true,
        name: "weight_in_gms"
    })
    weightInGms: number;

    @Column("int", {
        nullable: true,
        name: "count"
    })
    count: number;

    @Column('boolean', {
        name: 'is_qaqc_approved',
        default: false
    })
    isQAQCApproved: boolean;
}


